import { bunja } from 'bunja';
import { addHours, isAfter } from 'date-fns';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getExchangeWinnersApi } from '@flipster/apis/v1/exchange';
import { snapshotSpecBunja } from '@flipster/features/src/shared/snapshot/state';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

export const fomoBannerBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { instrumentsKeyBySymbolAtom } = bunja.use(snapshotSpecBunja);
  const fomoBannerStatusAtom = atom(false);
  function closeFomoBanner() {
    setLocalStorage('flipster.configs.v1.closeFomoBanner', Date.now());
    store.set(fomoBannerStatusAtom, false);
  }
  const exchangeWinnersQueryAtom = atomWithQuery(() => ({
    queryKey: ['getExchangeWinnersApi'],
    queryFn: getExchangeWinnersApi,
    select: (res) => res.data,
  }));
  const filteredExchangeWinnersAtom = atom((get) => {
    const { data } = get(exchangeWinnersQueryAtom);
    const instrumentsKeyBySymbol = get(instrumentsKeyBySymbolAtom);
    if (!data || !instrumentsKeyBySymbol) return [];
    return data.winners
      .filter((w) => !!instrumentsKeyBySymbol[w.symbol])
      .map((w) => ({ ...w, isSpot: instrumentsKeyBySymbol[w.symbol].isSpot }));
  });
  const tradeTabTextAtom = atom((get) => get(exchangeWinnersQueryAtom).data?.tradeTabText);
  const fomoBannerReadyAtom = atom((get) => get(fomoBannerStatusAtom) && get(filteredExchangeWinnersAtom).length >= 3);

  bunja.effect(() => {
    (() => {
      const hideFomoBannerTimestamp = getLocalStorage('flipster.configs.v1.closeFomoBanner');
      if (!hideFomoBannerTimestamp) return store.set(fomoBannerStatusAtom, true);
      const showAgainBannerTimestamp = addHours(hideFomoBannerTimestamp, 24 * 7); // 7일 후에 다시 보여줌
      if (isAfter(Date.now(), showAgainBannerTimestamp)) return store.set(fomoBannerStatusAtom, true);
      return store.set(fomoBannerStatusAtom, false);
    })();
    return () => {};
  });

  return {
    tradeTabTextAtom,
    filteredExchangeWinnersAtom,
    fomoBannerReadyAtom,
    closeFomoBanner,
  };
});
fomoBannerBunja.debugLabel = 'fomoBannerBunja';
